/* eslint-disable global-require */
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import UnitConstants from '../../constants/column-name/unit.column-name.constants';
import CustomerConstants from '../../constants/column-name/customer.column-name.constants';
import UnitFormConstants from '../../constants/form/unit.form.constants';
import Mappings from './UnitAutoCompleteMaps';

export default Vue.component('window', {
  beforeCreate() {
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
    this.$options.components.CustomerAutoComplete = require('../customer/CustomerAutoComplete.vue').default;
  },
  template: `  <AddEditForm title='${UnitFormConstants.FormTitle}' 
                  ref="addEditForm"
                  @submit-button-clicked="onFormSubmit" 
                  @dialog-closed="handleDialogClosed">
      <CustomerAutoComplete :formData="formData" :mapping="mappings.Customer" :tabindex="-1" />
      ${FormDataService.textInput(UnitConstants.unitName)}
      <AutoComplete
        :formData="formData"
        :mapping="mappings.ManufacturerModel"
        :hasDescription="true"
        :clearRightPadding="true"
        :removeOptionsLimit="true"
        store="ManufacturerModel"
        placeholder="Select Manufacturer">
        Manufacturer
      </AutoComplete>
      <AutoComplete
        :formData="formData"
        :mapping="mappings.UnitType"
        :clearRightPadding="true"
        :removeOptionsLimit="true"
        store="UnitType"
        placeholder="Select Unit Type">
        Unit Type
      </AutoComplete>
      <AutoComplete
        :formData="formData"
        :mapping="mappings.Fluid"
        :hasDescription="true"
        :clearRightPadding="true"
        :removeOptionsLimit="true"
        store="Fluid"
        placeholder="Select Fluid">
        Fluid
      </AutoComplete>
      <AutoComplete
        :formData="formData"
        :mapping="mappings.FluidUnitOfMeasure"
        :allowEmpty="false"
        :clearRightPadding="true"
        store="UnitOfMeasure"
        placeholder="Select Unit of Measure">
        Fluid UoM
      </AutoComplete>
      <AutoComplete
        :formData="formData"
        :mapping="mappings.MeterReadingUnitOfMeasure"
        :allowEmpty="false"
        :clearRightPadding="true"
        store="UnitOfMeasure"
        placeholder="Select Unit of Measure">
        Reading UoM
      </AutoComplete>
      ${FormDataService.textInput(UnitConstants.attention)}
      ${FormDataService.textInput(UnitConstants.suggestedInterval)}
      ${FormDataService.textareaInput(UnitConstants.comments, 3)}
  </AddEditForm>`,
  name: UnitFormConstants.FormName,
  data() {
    return {
      formData: {},
      mappings: Mappings,
      defaultCustomer: undefined
    };
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm() {
      return this.checkFormSubmission(UnitConstants);
    },
    openDialog(data) {
      this.formData = { ...data };
      if (this.defaultCustomer !== undefined) {
        this.formData[UnitConstants.customerId.field] = this.defaultCustomer[CustomerConstants.customerId.field];
        this.formData[UnitConstants.customerCode.field] = this.defaultCustomer[CustomerConstants.customerCode.field];
        this.formData[UnitConstants.customerName.field] = this.defaultCustomer[CustomerConstants.customerName.field];
        this.formData[UnitConstants.customerThirdParty.field] = this.defaultCustomer[
          CustomerConstants.customerThirdParty.field
        ];
        this.formData[UnitConstants.customerComment.field] = this.defaultCustomer[CustomerConstants.comments.field];
      }
      if (this.mappings !== undefined) {
        this.loadMappedAutoCompletes(this.mappings, this.formData);
      }
      this.$refs.addEditForm.openDialog(data);
    },
    handleDialogClosed() {
      this.$emit('dialog-closed');
    }
  },
  components: { AddEditForm }
});
